import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import { Team } from '../../../globals/interfaces';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    selectedTeam: Team | undefined;
    duplicateSchedule: () => Promise<void>;
}

export default function ModalConfirmDuplicate ({
    modal,
    setModal,
    selectedTeam,
    duplicateSchedule
}: Props) {

    const toggle = () => setModal(!modal);

    if (!selectedTeam) return null;

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Confirm Duplicate Schedule for {selectedTeam.name}</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <h6>Are you sure you want to duplicate the current week's schedule for the next week? This will overwrite any existing schedules for the following week.</h6>
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer update={true}>
                        <ActionIcon type={'cancel'} onClick={toggle} />
                        <ActionIcon type={'check'} onClick={duplicateSchedule} />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{update?: boolean}>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;